import Layout from './components/layout';
import Details from './components/details';


export default {
	Layout,
	Details
}